// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__37lbF","consentsList":"PatientConsents_consentsList__1u7oE","consentsListEmpty":"PatientConsents_consentsListEmpty__2CSdB"};